import { useEffect } from 'react';
import { useApplicationType } from '../common/hooks/use-application-type';

export function isValidRedirectUrl(url: string): boolean {
    try {
        const parsedUrl = new URL(url, window.location.origin);
        // Only allow same hostname
        return parsedUrl.hostname === window.location.hostname;
    } catch {
        return false;
    }
}

export function useRedirectHandler() {
    const { isFirstResponder } = useApplicationType();

    useEffect(() => {
        if (!isFirstResponder) {
            return;
        }

        const urlParams = new URLSearchParams(window.location.search);
        let redirectUrl = urlParams.get('redirect');

        // The hash fragment is part of the current page, not the redirect parameter
        // We need to append the current page's hash to the redirect URL
        if (redirectUrl && window.location.hash) {
            redirectUrl = redirectUrl + window.location.hash;
        }

        if (redirectUrl && isValidRedirectUrl(redirectUrl)) {
            window.location.replace(redirectUrl);
        }
    }, [isFirstResponder]);
}
